<div class="cart-totals-order">
  <div class="cart-totals-order-summary">
    <div class="cart-totals-order-bonus">
      @if (bonusAssignedAmount()) {
        <sd-bonus-widget [withWord]="true" [amount]="bonusAssignedAmount()"></sd-bonus-widget>
      }
    </div>
    <div class="cart-totals-order-price text-b2-s-900 text-md-b1-l-900">
      @if (cart().totalPrice) {
        <span class="text-b4-s-300 text-md-b2-s-500">итого</span>
        <span>{{ cart().totalPrice?.formattedValue }}</span>
      }
    </div>
  </div>

  <button sdButton type="primary" fullWidth="true" routerLink="/checkout">
    <span class="text-b3-s-500 text-lg-b2-s-500">перейти к оформлению</span>
  </button>
</div>
